import React from 'react'
import PropTypes from "prop-types";
import {Card, CardBody, Col, Row} from "reactstrap";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import label from "enqc-utilities/src/label/Label";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import BaseComponent from "../BaseComponent";

export default class AssemblyStatusMessageCard extends BaseComponent{

    constructor(props) {
        super(props);
        let state = this.state
        state.adminPerformer = {}
        this.setState(state)
    }


    async componentDidMount() {
        super.componentDidMount();
        await this.fetchAdminInformation(this.props)
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if(this.props!=nextProps){
    //         this.setState({}, async () => {
    //             await this.fetchAdminInformation(nextProps)
    //         })
    //     }
    // }

    async fetchAdminInformation(props){
        let {assembly} = props
        if(!assembly || !assembly.id){
            return
        }
        let params = {params:{assemblyId:assembly.id}}
        let response = await this.asyncGet(Endpoint.API.ASSEMBLY_STATUS_HISTORY_LAST_ONE, params, null, true, true);
        if(response.code===200){
            let {data} = response
            if(!data){
                data = {}
            }
            let {adminPerformer} = data
            if(!adminPerformer){
                adminPerformer = {}
            }
            this.setState({adminPerformer})
            return response ;
        }
    }


    render() {
        let {adminPerformer} = this.state
        if(!adminPerformer){
            adminPerformer = {}
        }
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        let {statusMessage} = assembly
        return (
            <Card className="bg-white shadow-sm mb-4 border-warning">
                <CardBody>
                    <Row>
                        <Col xs={12} lg={12} md={12} className="text-center font-italic fw-bold">
                            <strong>{label.Message} {adminPerformer.firstname?label.From+": "+adminPerformer.firstname:""}</strong>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col xs={12} lg={12} md={12} className="text-center bold fw-bold">
                            <h4 className="text-danger">{statusMessage}</h4>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        );
    }

}

AssemblyStatusMessageCard.propTypes = {
    assembly : PropTypes.any,
    headerClassName: PropTypes.string
}